import Parse from 'parse'
import moment from 'moment-timezone'
moment.tz.setDefault('America/Mexico_City');

class BlockedSchedule extends Parse.Object {
  
  constructor() {
    super('BlockedSchedule');
  }

  get date () {
    return moment(this.get('date')).format('dddd DD MMMM, YYYY')
  }

  static load (limit = 500, skip = 0) {
    return new Parse.Query(this)
      .limit(limit)
      .skip(skip)
      .descending('createdAt')
      .find()
  }

  static getHours(fecha) {
    
    let date = moment(fecha).date()
    let month = moment(fecha).month()
    let year = moment(fecha).year()
    
    let params = {
      date: date,
      month: month, 
      year: year,
      filtered: false
    }
    
    return Parse.Cloud.run('availableSchedules', params)
  }

  static blockedHours(date) {
    
    let unix_timestamp = date
    var convert = new Date(unix_timestamp * 1000);

    let blocked = new BlockedSchedule()  
    blocked.set('date', convert)

    return blocked.save()
  }

  static changeStatus(data) {
    
    var query = new Parse.Query(this);
    query.equalTo('date', moment(data.timestamp * 1000).toDate())
    
    return query.first()
  
  }

  destroyObject(data){

    const id = data.id
    let pc = BlockedSchedule.createWithoutData(id)

    return pc.destroy()
  }

  dump () {
    console.log(this)
  }
}

export default BlockedSchedule
